import { render, staticRenderFns } from "./PlatformAccountModal.vue?vue&type=template&id=294b4325"
import script from "./PlatformAccountModal.vue?vue&type=script&lang=js"
export * from "./PlatformAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports